// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.18425 13.8068C2.18686 8.93733 5.3258 4.1813 10.1953 3.18391L11.1749 2.98325L10.7736 1.02393L9.79394 1.22459C3.84237 2.44362 0.00589404 8.25654 1.22493 14.2081C2.44396 20.1597 8.25688 23.9962 14.2085 22.7771C18.7545 21.846 22.0643 18.2353 22.8329 13.9329L23.0088 12.9484L21.0399 12.5967L20.8641 13.5811C20.2346 17.1047 17.5238 20.0565 13.8071 20.8178C8.93767 21.8152 4.18164 18.6763 3.18425 13.8068Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.2886 1.23872L13.3105 1.03036L12.8938 2.98647L13.8719 3.19483C17.2667 3.91803 20.0779 6.58093 20.8181 10.1949L21.0188 11.1746L22.9781 10.7733L22.7775 9.7936C21.872 5.37312 18.4329 2.12158 14.2886 1.23872Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0012 17.0005C14.7626 17.0005 17.0012 14.7619 17.0012 12.0005C17.0012 9.23905 14.7626 7.00048 12.0012 7.00048C9.23979 7.00048 7.00121 9.23905 7.00121 12.0005C7.00121 14.7619 9.23979 17.0005 12.0012 17.0005Z"}}]};

const ChartRing1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-ring-1-filled',
    ref,
    icon: element,
  },
));

ChartRing1FilledIcon.displayName = 'ChartRing1FilledIcon';

export default ChartRing1FilledIcon;
